import React, { StrictMode } from 'react'
import { BrowserRouter } from 'react-router-dom'

// Components
import { Routes } from 'modules/core/router/components'
import { Layout } from '../'

// Providers
import { AuthProvider } from 'modules/auth/providers'
import { SportsProvider } from 'modules/sport/providers'

import 'bootstrap/dist/css/bootstrap.min.css'
import './app.styles.css'
import { ScrollToTop } from 'utils/routes/scrollToTop'

export const App = () => (
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SportsProvider>
          <Layout>
            <ScrollToTop />
            <Routes />
          </Layout>
        </SportsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
)
